@let currentFilter = filter();
@if (initialFilter.isLoading()) {
  <div class="flex items-center justify-center h-[30vh]">
    <ui-loading-spinner size="40" />
    <!-- todo: show analysis consumption loading skeleton -->
  </div>
} @else if (currentFilter) {
  <app-location-consumption-graph
    [organizationId]="organizationId()"
    [locationId]="locationId()"
    [filter]="currentFilter"
    [data]="data()"
    (clickReload)="onClickReload($event)"
    (changeFilter)="filter.set($event)"
  />
} @else {
  <app-error-component class="h-100" />
}
